'use strict';
	
export default class AccountNewController 
{
	/*@ngInject*/
	constructor(Auth, $state, $log, $controller, $http, ValidationService, vcRecaptchaService, $ocLazyLoad, messageService) 
	{
		//console.log("::AccountNewController");
		// Esta linea es necesaria para que el CommonController pueda acceder a vm desde $scope.vm
		//angular.extend(this, $controller('AccountCommonController', {$scope: $scope}));

		this.Auth = Auth;
		this.$state = $state;
		this.$log = $log;
		this.validation = new ValidationService();
		this.messageService = messageService;
		
		this.user = {};
		this.emailDisabled = false;
		this.showError = false;

		this.recaptchaResponse = null;
		this.recaptchaWidget = null;
		this.recaptchaKey = '6Lfk89cSAAAAALYE8fl-R8iaRaPKkhSQXdkaDf7i';
		this.vcRecaptchaService = vcRecaptchaService;

		$http.post("/api/geonames/countries")
		.then(response => {
			this.countries = response.data;
		});

		$ocLazyLoad.load(['https://www.google.com/recaptcha/api.js?onload=vcRecaptchaApiLoaded&render=explicit']);
	}

	// Recaptcha
	//@{
	setResponse(response) 
	{
		//console.info('Response available');
		//console.info(response);
		this.recaptchaResponse = response;
	}

	setWidgetId(widgetId) 
	{
		//console.info('Created widget ID: %s', widgetId);
		this.recaptchaWidget = widgetId;
	}

	cbExpiration() 
	{
		//console.info('Captcha expired. Resetting response object');
		this.vcRecaptchaService.reload(this.recaptchaWidget);
		this.recaptchaResponse = null;
	}
	//@}

	/*OnDummy()
	{
		this.user.name = "Nombre aquí";
		this.user.surname = "Apellido aqui";
		this.user.nick = "Nick aquí";
		this.user.email = "sergiorg@gmail.com";
		this.user.password = "hola1234";
		this.user.confirmPassword = "hola1234";

		this.user.twitter = "@gusitwits";
		this.user.web = "http://everlaps.com";
		this.user.about = "Lorem ipsum... áéíóú";
		this.user.accepted = true;
	}*/

	CheckExistingEmail() 
	{
		return this.Auth.checkEmailExists(this.user.email)
		.then(response => { 
			return response.data;
		})
		.catch(() => { 
			return { isValid: false, message: 'Unknown error' }; 
		});
	}

	Register(form) 
	{
		this.showError = false;
	
		if (!this.validation.checkFormValidity(form)) 
		{
			this.showError = true;
			return;
		}
/*
		if (!this.legalNotice || !this.privacyPolicy)
		{
			if (!this.legalNotice)
				this.message = this.message + " - " + this.$translate.instant("SIGNUP_no_legalNotice");
			if (!this.privacyPolicy)
				this.message = this.message + " - " + this.$translate.instant("SIGNUP_no_privacyPolicy");
			return;
		}
*/

		this.Auth.createUser({
			name: this.user.name,
			surname: this.user.surname,
			nick: this.user.nick,
			email: this.user.email,
			password: this.user.password,
			country: this.user.country ? this.user.country.iso2 : null,
			region1: this.user.region1 ? this.user.region1.id : null,
			region2: this.user.region2 ? this.user.region2.id : null,
			club: this.user.club,
			twitter: this.user.twitter,
			web: this.user.web,
			about: this.user.about,
			recaptcha: this.recaptchaResponse
		})
		.then(() => {
			// Account created, redirect to home
			this.$state.go('justregistered', { email: this.user.email, name: this.user.name });
		})
		.catch(err => {
			this.$log.warn(err);
			this.showError = true;
			this.messageService.Error(err.data);
		});
	}
}



// WEBPACK FOOTER //
// ./client/app/account/account/account_new.controller.js